var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F2FCADEC-235C-4F4D-AB80-B038AF9D37DF@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/Player-active",
    transform: "translate(-582.000000, -686.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pause",
    transform: "translate(582.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,0 C39.5832611,0 51,11.4167389 51,25.5 C51,39.5832611 39.5832611,51 25.5,51 C11.4167389,51 0,39.5832611 0,25.5 C0,11.4167389 11.4167389,0 25.5,0 Z M20.6956522,14.0434783 C19.4710208,14.0434783 18.4782609,15.0362382 18.4782609,16.2608696 L18.4782609,16.2608696 L18.4782609,34.7391304 C18.4782609,35.9637618 19.4710208,36.9565217 20.6956522,36.9565217 C21.9202836,36.9565217 22.9130435,35.9637618 22.9130435,34.7391304 L22.9130435,34.7391304 L22.9130435,16.2608696 C22.9130435,15.0362382 21.9202836,14.0434783 20.6956522,14.0434783 Z M30.3043478,14.0434783 C29.0797164,14.0434783 28.0869565,15.0362382 28.0869565,16.2608696 L28.0869565,16.2608696 L28.0869565,34.7391304 C28.0869565,35.9637618 29.0797164,36.9565217 30.3043478,36.9565217 C31.5289792,36.9565217 32.5217391,35.9637618 32.5217391,34.7391304 L32.5217391,34.7391304 L32.5217391,16.2608696 C32.5217391,15.0362382 31.5289792,14.0434783 30.3043478,14.0434783 Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause15X);
export default __webpack_public_path__ + "static/media/Pause@1.5x.2fe82e53572894c08d80c799314d636e.svg";
export { ForwardRef as ReactComponent };